import React from 'react'
import {
  Wrapper,
  Bg,
  Content,
  Logo,
  ImgIsabel,
  Children,
  ImgBg,
  Banner,
} from './style.css'
import { StaticImage } from 'gatsby-plugin-image'

const Hero = ({ children }) => {
  return (
    <Wrapper>
      <div className="relative sm:mt-10">
        <StaticImage
          className="hidden sm:block"
          layout="fullWidth"
          src="../../../images/bg2.jpg"
          alt=""
          quality={`80`}
          transformOptions={{ fit: 'cover' }}
        />
        <StaticImage
          className="block sm:hidden"
          layout="fullWidth"
          src="../../../images/bgmob.jpg"
          alt=""
          quality={`80`}
          transformOptions={{ fit: 'cover' }}
        />
      </div>
      <Content>
        <Children>{children}</Children>
      </Content>
      <Bg></Bg>
    </Wrapper>
  )
}

export default Hero
